import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { Badge } from "antd";
import StandardTableLayout from "../../layouts/StandardTableLayout/StandardTableLayout";
import StandardListLayout from "../../layouts/StandardTableLayout/StandardListLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  FETCH_ALL_INDUSTRY,
  setIndustry,
  DELETING_INDUSTRY,
} from "../../store/contact-store/reducer";

const Industry = () => {
  const dispatch = useDispatch();
  const { organisationId } = useSelector(({ auth }) => auth.user);
  const { csvExportData } = useSelector(({ user }) => user.userReducer);
  const { industry } = useSelector(({ contact }) => contact.contactReducer);
  const [dataList, setDataList] = useState([]);

  const [csv, setCsv] = useState({
    headers: [
      {
        label: "Description",
        key: "description",
      },
      {
        label: "Status",
        key: "status",
      },
    ],
    data: [],
    fileName: "allPositions.csv",
  });
  const [isLoading, setIsLoading] = useState(true);
  const columns = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let type = status === true ? "success" : "error";
        return <Badge status={type} text={status ? "Active" : "InActive"} />;
      },
      sorter: (a, b) => b.status - a.status,
    },
  ];

  const handleColumnCsv = (array) => {
    let csvData = [];
    array.forEach((e) => {
      csvData.push({
        description: e.description,
        status: e.status,
      });
    });
    return csvData;
  };

  const FETCH_DATA = () => {
    FETCH_ALL_INDUSTRY(organisationId)
      .then((data) => {
        dispatch(setIndustry(data));
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    FETCH_DATA();
  }, [organisationId]);

  useEffect(() => {
    if (industry) {
      const columns = handleColumnCsv(industry);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [industry]);

  useEffect(() => {
    if (csvExportData.length > 0) {
      const columns = handleColumnCsv(csvExportData);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [csvExportData]);

  useEffect(() => {
    const newDoc = [];
    industry?.forEach((ele, index) => {
      let data = {
        _id: ele?._id,
        title: `${ele?.description}`,
        description: `${ele?.status ? "Active" : "Inactive"}`,
      };
      newDoc.push(data);
    });
    setDataList(newDoc);
  }, [industry]);

  return (
    <div className="table-organisations table-payments">
      <div className="table-layouts">
        <div className="tables">
          <StandardTableLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Industry" }]}
            dataSource={industry}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETING_INDUSTRY}
            table="contact/industry"
          />
        </div>
        <div className="table-lists">
          <StandardListLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Industry" }]}
            dataList={dataList}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETING_INDUSTRY}
            table="contact/industry"
          />
        </div>
      </div>
    </div>
  );
};

export default Industry;
